import React, { useEffect, useState } from "react";
import { Buildings, Brain, Users, EnvelopeSimple, ShieldCheck, Ranking, CheckCircle } from "@phosphor-icons/react";

const STEPS = [
  { icon: Buildings, label: "Resolving company" },
  { icon: Brain, label: "Understanding target role" },
  { icon: Users, label: "Finding relevant people" },
  { icon: EnvelopeSimple, label: "Enriching contact information" },
  { icon: ShieldCheck, label: "Verifying emails" },
  { icon: Ranking, label: "Ranking contacts" },
];

export default function SearchProgress({ company, role }) {
  const [step, setStep] = useState(0);

  useEffect(() => {
    const t = setInterval(() => setStep((s) => (s < STEPS.length - 1 ? s + 1 : s)), 550);
    return () => clearInterval(t);
  }, []);

  return (
    <div className="max-w-xl mx-auto px-8 py-24">
      <div className="mb-10 text-center">
        <div className="inline-flex items-center gap-2 mb-4">
          {company?.logo && <img src={company.logo} alt="" className="w-8 h-8 rounded-md object-contain" onError={(e) => (e.target.style.display = "none")} />}
          <span className="font-head text-2xl font-bold tracking-tight">{company?.name}</span>
        </div>
        <p className="text-sm text-zinc-500">Finding decision-makers for "{role}"</p>
      </div>

      <div className="space-y-3">
        {STEPS.map((s, i) => {
          const done = i < step;
          const active = i === step;
          return (
            <div key={i} className={`flex items-center gap-4 p-4 rounded-lg border transition-colors ${
              active ? "border-zinc-900 bg-white shadow-sm" : done ? "border-zinc-200 bg-white" : "border-zinc-100 bg-zinc-50/50"
            }`}>
              <div className={`w-9 h-9 rounded-md flex items-center justify-center ${
                done ? "bg-emerald-50 text-emerald-600" : active ? "bg-zinc-900 text-white" : "bg-zinc-100 text-zinc-400"
              }`}>
                {done ? <CheckCircle size={18} weight="fill" /> : active ? (
                  <div className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin" />
                ) : <s.icon size={18} />}
              </div>
              <span className={`text-sm font-medium ${active || done ? "text-zinc-900" : "text-zinc-400"}`}>
                {s.label}{active ? "…" : ""}
              </span>
            </div>
          );
        })}
      </div>
    </div>
  );
}
